module.exports = __webpack_public_path__ + "static/nav-contact-1-59c191b2d238b57184be792e7b4e1e14.jpg";